import axios from 'axios'
import ActionCreators from '../store/actions';
import { store } from '../store/configureStore'

const baseURL = process.env.DIRECTUS_API_URL || '/'

const api = axios.create({
  baseURL
})
// Request interceptor
api.interceptors.request.use(
  async config => {
    const { accessToken, tokenExpires } = store.getState().user
    const routesWithNoAuth = [
      '/auth/refresh',
      '/custom/auth/login',
    ]
    // console.log(config.url)
    if (!routesWithNoAuth.includes(config.url as string) && tokenExpires) {
      const MIN_IN_MS = 60000;
      const expiryDeadline = (new Date(tokenExpires).getTime() - 1 * MIN_IN_MS)
      const now = new Date().getTime()

      if (now > expiryDeadline) {
        await store.dispatch(ActionCreators.refreshUser())
        // return config
      }

      if (accessToken) {
        Object.assign(config, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
      }
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  error => {
    Promise.reject(error)
  });

// Response interceptor
// api.axios.interceptors.response.use(
//   (response) => {
//     return response
//   },
//   async (error) => {
//     const originalRequest = error.config

//     const INVALID_CREDENTIALS = error.response.status === 401
//     return Promise.reject(error)
//   }
// )

export default api
